export const defaultFontStack = "Lato, sans-serif"
export const defaultFontSize = "14px"

export const defaultFont = `${defaultFontSize} ${defaultFontStack}`
export const defaultBoldFont = `bold ${defaultFont}`
export const defaultItalicFont = `italic ${defaultFont}`

export const defaultTileTitleFont = defaultItalicFont

export const kTitleBarHeight = 25

export const kDefaultTileWidth = 250
export const kDefaultTileHeight = 250

export const kCodapAppElementId = "codap-app-id"
